<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	type Item = {
		label: string;
		value: string;
	};

	export let items: Item[] = [];
	let className: string = '';
	export { className as class };
</script>

<div class={twMerge('flex flex-col overflow-hidden rounded-xl bg-light', className)}>
	<div class="flex grow flex-col justify-center px-2 py-5">
		<slot {items}>
			<ul
				class="grid w-full grid-cols-3 items-end justify-between gap-x-10 gap-y-5 self-center px-5 md:px-7"
			>
				{#each items as item}
					<li class="flex justify-center">
						<div class="whitespace-nowrap">
							<p class="text-xs">{item.label}</p>
							<p class="font-semibold">{item.value}</p>
						</div>
					</li>
				{/each}
			</ul>
		</slot>
	</div>
</div>
